<template>
    <u-card-border-top v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-card-border-top>
</template>

<script>
import UCardBorderTop from "@/components/publish/styles/cards/u-card-border-top.vue";

export default {
    props: {},
    components: {
        UCardBorderTop,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
